/*
 * Public API Surface of ngx-lib/quantity-selector
 */
export * from './quantity-selector.module';
export * from './quantity-selector.component';
